import { SPINNER_SHOW, SPINNER_HIDE, SPINNER_ACTIVATION, SPINNER_PROGRESS, } from './action-creators';
import { PAGE_UPDATE_SUCCESS, PAGE_LOAD_ABORTED, PAGE_LOAD_DONE, PAGE_LOAD_FAILURE, } from '../CurrentPage/action-creators';
export default function (state = null, action) {
    if (state === null) {
        state = {
            isVisible: false,
            isCommunicatingWithServer: false,
            progress: 1,
        };
    }
    switch (action.type) {
        case SPINNER_SHOW:
            return Object.assign(Object.assign({}, state), { isVisible: true });
        case SPINNER_HIDE:
            return Object.assign(Object.assign({}, state), { isVisible: false });
        case SPINNER_ACTIVATION: {
            const spinnerActivationAction = action;
            return Object.assign(Object.assign({}, state), { isCommunicatingWithServer: spinnerActivationAction.active });
        }
        case SPINNER_PROGRESS: {
            const spinnerProgressAction = action;
            return Object.assign(Object.assign({}, state), { progress: spinnerProgressAction.progress });
        }
        case PAGE_UPDATE_SUCCESS:
        case PAGE_LOAD_ABORTED:
        case PAGE_LOAD_DONE:
        case PAGE_LOAD_FAILURE:
            return {
                isVisible: false,
                isCommunicatingWithServer: false,
                progress: 1,
            };
        default:
            return state;
    }
}
